import * as types from "../constants/DashboardActionTypes";

const initState = {
  data: {
    completedShoots: null,
    onGoingShootsTable: [],
    ongoingShoots: null,
    photoShots: null,
    scheduledShoots: null,
    shooters: null,
    videoShots: null
  },
  fetching: true,
  failed: false,
  fetched: false
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case types.DASHBOARD_FETCHING:
      return Object.assign({}, state, {
        fetching: true
      });
    case types.DASHBOARD_FETCHED:
      return Object.assign({}, state, {
        data: { ...action.data },
        fetched: true,
        fetching: false
      });
    case types.DASHBOARD_FAILED:
      return Object.assign({}, state, {
        fetching: false,
        failed: true,
        fetched: true
      });
    default:
      return state;
  }
};

export default reducer;
